import { Component, EventEmitter, Input, Output, OnInit, ElementRef, AfterViewInit, OnDestroy } from "@angular/core";

@Component({
    selector: 'upsell-sticky-bar',
    templateUrl: 'upsell-sticky-bar.html',
    styleUrls: ['upsell-sticky-bar.scss'],
    standalone: false
})
export class UpsellStickyBar implements OnInit, AfterViewInit, OnDestroy {
  @Input() buttonYesText: string = 'Yes I want this special added to my order';
  @Input() buttonNoText: string = 'No thanks, I understand that I won\'t see this offer again';
  @Input() displayAfterMobile: string = '';

  @Output() eventEmitter: EventEmitter<boolean> = new EventEmitter();

  private scrollListener: (() => void) | null = null;

  constructor(private elementRef: ElementRef) {}

  nextPage(buttonValue: boolean) {
    this.eventEmitter.emit(buttonValue);
  }

  ngOnInit() {
    if (this.displayAfterMobile) {
      this.elementRef.nativeElement.classList.add('hidden');
    }
  }

  ngAfterViewInit() {
    if (this.displayAfterMobile) {
      this.setupScrollListener();
    }
  }

  ngOnDestroy() {
    if (this.scrollListener) {
      window.removeEventListener('scroll', this.scrollListener);
    }
  }

  private setupScrollListener() {
    this.scrollListener = () => {
      const triggerElement = document.querySelector(this.displayAfterMobile) as HTMLElement;
      if (triggerElement) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        this.elementRef.nativeElement.classList.toggle('hidden', scrollTop < triggerElement.offsetTop);
      }
    };

    window.addEventListener('scroll', this.scrollListener);
    this.scrollListener(); // run once so state is correct on load
  }
}
